import { InjectionToken } from '@angular/core'
import { EventHubGetProvider } from './signup.interface'

export const EVENT_HUB_GET_PROVIDER = new InjectionToken<EventHubGetProvider>('EVENT_HUB_GET_PROVIDER')
